import React from 'react';
import AboutImage from './AboutImage';
import './about.css';

const AboutMissionSection = ({ data }) => {
    if (!data) return null;

    return (
        <section className="w-full bg-white py-10 lg:py-14 about-section-divider">
            <div className="about-shell">
                <div className="about-mission-grid">
                    <div className="flex flex-col justify-center min-w-0">
                        <h2 className="text-xl md:text-2xl font-black text-[#E31E24] uppercase tracking-tight mb-3">
                            {data.missionTitle || 'SỨ MỆNH'}
                        </h2>
                        <p className="text-slate-700 text-sm md:text-[14.5px] leading-relaxed text-justify whitespace-pre-line">
                            {data.missionContent}
                        </p>
                    </div>

                    <div className="about-media-box about-media-box--mission min-w-0">
                        <AboutImage
                            src={data.missionImage}
                            fallback="/assets/images/bao-duong-gam-xe-o-to-4.jpg"
                            alt={data.missionTitle || 'Sứ mệnh'}
                            variant="banner"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutMissionSection;
